export function formatDateTime(unixInSec: number, includeDate: boolean) {
  const unixInMSecs = unixInSec * 1000;
  const timezoneOffsetMSecs = new Date(unixInMSecs).getTimezoneOffset() * 60000;
  const newDate = new Date(unixInMSecs + timezoneOffsetMSecs)
  let hr = newDate.getHours().toString();
  let min = newDate.getMinutes().toString();
  let day = newDate.getDate();
  let month = newDate.getMonth();
  let year = newDate.getFullYear();
  let date = [month + 1, day, year].join("/");

  let digits: String[] = [hr, min];
  digits = digits.map(digit => {
    if(digit.length === 1) {
      return "0" + digit;
    } else {
      return digit;
    }
  })
  let time = digits.join(":");
  if(includeDate) {
    return date + " " + time;
  } else {
    return time;
  }
}



// WEBPACK FOOTER //
// ./src/utils/format-time.ts